import React, { useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { makeStyles } from '@mui/styles';
import { colors, Grid } from '@mui/material';
import { FetchDownloads } from 'actions';
import { Page, Header } from 'components';
import { DownloadList } from './components';

const useStyles = makeStyles((theme) => ({
	root: {
		padding: theme.spacing(3),
	},
	tabs: {
		marginTop: theme.spacing(3),
	},
	divider: {
		backgroundColor: colors.grey[300],
	},
	alert: {
		marginTop: theme.spacing(3),
	},
	content: {
		marginTop: theme.spacing(3),
	},
}));

const Downloads = (props) => {
	const classes = useStyles();

	const dispatch = useDispatch();
	const user = useSelector(state => state.session.user);
	const files = useSelector(state => state.session.downloads);

	useEffect(() => {
		dispatch(FetchDownloads(user.id, 'all'));
	}, []);

	return (
		<Page className={classes.root} title="Downloads">
			<Header module="Downloads" view="All files" />
			<Grid className={classes.content} container spacing={3}>
				<Grid item lg={12} xs={12}>
					<DownloadList files={files} />
				</Grid>
			</Grid>
		</Page>
	);
};

export default Downloads;
